module.exports = __webpack_public_path__ + "img/doctor-computer-WIDE.bf4f7c3a.jpg";